import { Component, Ref } from 'vue-property-decorator';
import { PropsMixin } from './PropsMixin';
import { SwiperOptions } from './types';

@Component
export class BaseSlider extends PropsMixin {
    /**
     *
     */
    @Ref()
    public readonly swiper!: InstanceType<typeof import('vue-awesome-swiper').Swiper>;
    /**
     *
     */
    @Ref()
    public readonly navigation!: HTMLElement;
    /**
     *
     */
    public swiperOptions: SwiperOptions | null = null;
    /**
     *
     */
    public slidesCount: number = 0;
    /**
     *
     */
    public activeIndex: number = 0;
    /**
     *
     */
    public slideNext(speed?: number, runCallbacks?: boolean) {
        this.swiper.swiperInstance!.slideNext(speed, runCallbacks);
    }
    /**
     *
     */
    public slidePrev(speed?: number, runCallbacks?: boolean) {
        this.swiper.swiperInstance!.slidePrev(speed, runCallbacks);
    }
    /**
     *
     */
    public slideTo(index: number, speed?: number, runCallbacks?: boolean) {
        this.swiper.swiperInstance!.slideTo(index, speed, runCallbacks);
    }
    /**
     *
     */
    public onReady() {
        if (typeof this.sliderActiveSlide === 'number') {
            this.slideTo(this.sliderActiveSlide, 0);
        }

        this.slidesCount = this.swiper.swiperInstance!.slides?.length;
        this.activeIndex = this.swiper.swiperInstance!.realIndex;
    }
    /**
     *
     */
    public slideChange() {
        this.slidesCount = this.swiper.swiperInstance!.slides?.length;
        this.activeIndex = this.swiper.swiperInstance!.realIndex;
    }
    /**
     *
     */
    public onClickPrev() {
        const swiper = this.swiper.swiperInstance!;
        const { realIndex, slides } = swiper;
        if (realIndex === 0) {
            this.slideTo(slides.length - 1);
        } else {
            this.slidePrev();
        }
    }
    /**
     *
     */
    public onClickNext() {
        const swiper = this.swiper.swiperInstance!;
        const { realIndex, slides } = swiper;
        if (realIndex + 1 === slides?.length) {
            this.slideTo(0);
        } else {
            this.slideNext();
        }
    }
    /**
     *
     */
    public onClickUrl(url: string) {
        window.open(url);
    }
    /**
    *
    */
    public widthClient: number = window.screen.width;

    public widthClientUpdate() {
        this.widthClient = window.screen.width;
    }

}
